<script setup lang="ts">
import { computed } from 'vue'
import { Badge } from '@kyoto2/components/ui/badge'

const props = defineProps<{ status: string }>()

const variant = computed(() => {
  switch (props.status) {
    case 'success':
    case 'completed':
    case 'running':
    case 'active':
      return 'default'
    case 'failed':
      return 'destructive'
    case 'pending':
    case 'skipped':
      return 'secondary'
    case 'paused':
      return 'default'
    case 'cancelled':
      return 'outline'
    default:
      return 'secondary'
  }
})

const statusClass = computed(() => {
  switch (props.status) {
    case 'success':
    case 'completed':
    case 'active':
      return 'bg-emerald-600 hover:bg-emerald-600'
    case 'running':
      return 'bg-blue-600 hover:bg-blue-600'
    case 'paused':
      return 'bg-amber-600 hover:bg-amber-600'
    default:
      return ''
  }
})
</script>

<template>
  <Badge :variant="variant" :class="['capitalize', statusClass]">
    <span v-if="status === 'running'" class="mr-0.5 h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
    {{ status }}
  </Badge>
</template>
